// MatchFlow i18n fallback
export default {
  "matchflow.brand": "MatchFlow",
  "matchflow.lead":
    "Arbeitsplatz für die Betreuung zugewiesener Vereine — Vorgänge öffnen bestehende Fachprozesse.",
  "matchflow.loading": "Laden …",
  "matchflow.nav.aria": "MatchFlow Navigation",
  "matchflow.nav.inbox": "Arbeitsvorrat",
  "matchflow.nav.clients": "Kunden",
  "matchflow.nav.agreements": "Vereinbarungen",
  "matchflow.gate.loginRequired": "Bitte anmelden, um MatchFlow zu nutzen.",
  "matchflow.gate.forbiddenTitle": "Kein Mitarbeiterzugang",
  "matchflow.gate.forbidden":
    "Kein MatchFlow-Mitarbeiterzugang. Bitte einen Admin um Freischaltung bitten.",
  "matchflow.gate.error": "Zugriff konnte nicht geprüft werden.",
  "hub.matchflow.title": "MatchFlow",
  "hub.matchflow.subtitle": "Verwaltungszentrale für betreute Vereine",
  "matchflow.clients.title": "Zugewiesene Kunden",
  "matchflow.clients.count": "{count} Kunden",
  "matchflow.clients.empty": "Noch keine Kundenvereine zugewiesen.",
  "matchflow.clients.emptyHint":
    "Auch als Admin brauchst du eine Kundenzuweisung (MatchFlow-Assignment), damit Vereine hier und in der Inbox erscheinen.",
  "matchflow.clients.loadError": "Kundenliste konnte nicht geladen werden.",
  "matchflow.clients.switchError": "Kundenkontext konnte nicht gesetzt werden.",
  "matchflow.clients.hint":
    "Du bleibst als MatchFlow-Mitarbeiter angemeldet. Der Button öffnet TrainingsDesk im Kontext dieses Vereins — keine Anmeldung als Vereins-User.",
  "matchflow.clients.workAs": "In TrainingsDesk öffnen",
  "matchflow.clients.col.club": "Verein",
  "matchflow.clients.col.city": "Ort",
  "matchflow.clients.col.action": "Aktion",
  "matchflow.inbox.title": "Arbeitsvorrat",
  "matchflow.inbox.count": "{count} offen",
  "matchflow.inbox.countLabel": "offene Vorgänge",
  "matchflow.inbox.listTitle": "Vorgänge",
  "matchflow.inbox.empty": "Keine offenen Vorgänge für deine Kunden.",
  "matchflow.inbox.emptyHint":
    "Neue Signale (Anwesenheit, Abrechnung, Ausfälle) erscheinen automatisch in dieser Inbox.",
  "matchflow.inbox.clientsHint": "Zugewiesene Kundenvereine: {count}",
  "matchflow.inbox.loadError": "Inbox konnte nicht geladen werden.",
  "matchflow.inbox.open": "Bearbeiten",
  "matchflow.inbox.col.club": "Kunde",
  "matchflow.inbox.col.signal": "Vorgang",
  "matchflow.inbox.col.reason": "Warum",
  "matchflow.inbox.col.action": "Aktion",
  "matchflow.inbox.typeCount": "{label} · {count}",
  "matchflow.autopilot.attendance.title": "Autopilot Anwesenheit",
  "matchflow.autopilot.attendance.hint":
    "Regelkonforme Alt-Trainings (≥ 24h) bestätigen; Einspruch danach möglich.",
  "matchflow.autopilot.attendance.run": "Autopilot starten ({count})",
  "matchflow.autopilot.attendance.running": "Autopilot läuft …",
  "matchflow.autopilot.attendance.result":
    "Autopilot fertig: {confirmed} bestätigt, {skipped} übersprungen.",
  "matchflow.autopilot.attendance.error":
    "Autopilot Anwesenheit ist fehlgeschlagen.",
  "matchflow.autopilot.billing.title": "Autopilot Rechnung",
  "matchflow.autopilot.billing.hint":
    "Freigabefähige Entwürfe per E-Mail versenden. Merge nötig, fehlende Mail oder Einspruch → manuell.",
  "matchflow.autopilot.billing.run": "Rechnungen versenden ({count})",
  "matchflow.autopilot.billing.running": "Rechnungen werden versendet …",
  "matchflow.autopilot.billing.result":
    "Autopilot Rechnung: {released} versendet, {skipped} übersprungen.",
  "matchflow.autopilot.billing.error": "Autopilot Rechnung ist fehlgeschlagen.",
  "matchflow.autopilot.payment.title": "Autopilot Zahlung",
  "matchflow.autopilot.payment.hint":
    "Eindeutige Bank-Matches (Score ≥95) zuerst sichten, dann manuell bestätigen.",
  "matchflow.autopilot.payment.run": "Vorschläge prüfen",
  "matchflow.autopilot.payment.running": "Vorschläge werden geladen …",
  "matchflow.autopilot.payment.result":
    "Autopilot Zahlung: {matched} zugeordnet, {skipped} übersprungen.",
  "matchflow.autopilot.payment.error": "Autopilot Zahlung ist fehlgeschlagen.",
  "matchflow.autopilot.payment.reviewTitle": "Zahlungen prüfen",
  "matchflow.autopilot.payment.reviewLead":
    "Nur ausgewählte Vorschläge werden verbucht. Übersprungene bleiben offen.",
  "matchflow.autopilot.payment.proposalsTitle": "Vorschläge ({count})",
  "matchflow.autopilot.payment.proposalsEmpty":
    "Keine eindeutigen Matches (Score ≥95) gefunden.",
  "matchflow.autopilot.payment.skippedTitle": "Übersprungen ({count})",
  "matchflow.autopilot.payment.skippedEmpty": "Nichts übersprungen.",
  "matchflow.autopilot.payment.skippedTop":
    "bester Treffer: {player} (Score {score})",
  "matchflow.autopilot.payment.mapsTo":
    "→ {player} · {training} · Score {score}",
  "matchflow.autopilot.payment.unknown": "unbekannt",
  "matchflow.autopilot.payment.confirm": "Ausgewählte zuordnen ({count})",
  "matchflow.autopilot.payment.confirming": "Zuordnung läuft …",
  "matchflow.autopilot.payment.cancel": "Abbrechen",
  "matchflow.autopilot.payment.skip.no_candidate":
    "Kein passender offener Posten",
  "matchflow.autopilot.payment.skip.not_unique": "Kein eindeutiger Best-Match",
  "matchflow.autopilot.payment.skip.below_threshold": "Score unter 95",
  "matchflow.autopilot.payment.skip.apply_failed": "Verbuchtung fehlgeschlagen",
  "matchflow.autopilot.payment.skip.not_selected": "Nicht ausgewählt",
  "matchflow.signal.unconfirmed_attendance": "Unbestätigte Anwesenheit",
  "matchflow.signal.attendance_dispute": "Einspruch Anwesenheit",
  "matchflow.signal.billing_dispute": "Einspruch Rechnung",
  "matchflow.signal.billing_ready_for_release": "Rechnung freigeben",
  "matchflow.signal.payment_match_needed": "Zahlung zuordnen",
  "matchflow.signal.trainer_absence_impact": "Trainerausfall",
  "matchflow.contracts.title": "Club-Vertrag anlegen",
  "matchflow.contracts.lead":
    "B2B-Vertragspaket für den betreuten Verein: Umfang, Laufzeit, Dokumente (AGB, Angebot, DSGVO …). Du sendest einen Magic-Link; der Club-Ansprechpartner bestätigt digital.",
  "matchflow.contracts.listTitle": "Verträge des Kunden",
  "matchflow.contracts.count": "{count} Verträge",
  "matchflow.contracts.empty": "Noch keine Club-Verträge für diesen Kunden.",
  "matchflow.contracts.loadError": "Verträge konnten nicht geladen werden.",
  "matchflow.contracts.saveError": "Speichern fehlgeschlagen.",
  "matchflow.contracts.saved": "Vertrag gespeichert.",
  "matchflow.contracts.create": "Vertrag anlegen",
  "matchflow.contracts.updateSelected": "Auswahl speichern",
  "matchflow.contracts.open": "Öffnen",
  "matchflow.contracts.send": "An Club senden",
  "matchflow.contracts.sending": "Senden …",
  "matchflow.contracts.sendError": "Einladung konnte nicht erstellt werden",
  "matchflow.contracts.mailError": "Mail-Versand fehlgeschlagen",
  "matchflow.contracts.sent": "Einladung gesendet an {email}.",
  "matchflow.contracts.sendInviteOnly":
    "Einladung erstellt für {email}, Mail fehlgeschlagen. Link: {url}",
  "matchflow.contracts.field.title": "Titel",
  "matchflow.contracts.field.scope": "Vertragsumfang",
  "matchflow.contracts.field.validFrom": "Laufzeit von",
  "matchflow.contracts.field.validTo": "Laufzeit bis",
  "matchflow.contracts.field.term": "Laufzeit",
  "matchflow.contracts.field.counterpartyName": "Ansprechpartner",
  "matchflow.contracts.field.counterpartyEmail": "E-Mail Ansprechpartner",
  "matchflow.contracts.field.docType": "Dokumentart",
  "matchflow.contracts.field.docTitle": "Dokumenttitel",
  "matchflow.contracts.field.docUrl": "Dokument-URL",
  "matchflow.contracts.col.title": "Titel",
  "matchflow.contracts.col.status": "Status",
  "matchflow.contracts.col.term": "Laufzeit",
  "matchflow.contracts.col.signature": "Unterschrift",
  "matchflow.contracts.col.action": "Aktion",
  "matchflow.contracts.status.draft": "Entwurf",
  "matchflow.contracts.status.sent": "Gesendet",
  "matchflow.contracts.status.accepted": "Angenommen",
  "matchflow.contracts.status.active": "Aktiv",
  "matchflow.contracts.status.ended": "Beendet",
  "matchflow.contracts.status.cancelled": "Storniert",
  "matchflow.contracts.signedBy": "{name} · {at}",
  "matchflow.contracts.docCount": "{count} Dokumente",
  "matchflow.contracts.docsTitle": "Dokumente",
  "matchflow.contracts.docsLead": "Dokumente für „{title}“",
  "matchflow.contracts.docError": "Dokument konnte nicht hinzugefügt werden.",
  "matchflow.contracts.docAdded": "Dokument hinzugefügt.",
  "matchflow.contracts.addDocUrl": "URL hinzufügen",
  "matchflow.contracts.uploadDoc": "Datei hochladen",
  "matchflow.contracts.openDoc": "Öffnen",
  "matchflow.contracts.docType.agb": "AGB",
  "matchflow.contracts.docType.offer": "Angebot",
  "matchflow.contracts.docType.order_confirmation": "Auftragsbestätigung",
  "matchflow.contracts.docType.dsgvo": "DSGVO",
  "matchflow.contracts.docType.nda": "NDA",
  "matchflow.contracts.docType.other": "Sonstiges",
  "matchflow.accept.title": "Vertrag bestätigen",
  "matchflow.accept.intro":
    "{club}: bitte Dokumente prüfen und den Vertrag „{title}“ bestätigen.",
  "matchflow.accept.docsTitle": "Dokumente",
  "matchflow.accept.required": "Pflicht",
  "matchflow.accept.noFile": "Kein Dateilink hinterlegt",
  "matchflow.accept.field.name": "Vollständiger Name",
  "matchflow.accept.field.email": "E-Mail",
  "matchflow.accept.legal":
    "Mit Bestätigung erklärst du, die markierten Dokumente gelesen zu haben und dem Vertrag zuzustimmen.",
  "matchflow.accept.submit": "Vertrag bestätigen",
  "matchflow.accept.submitting": "Wird gespeichert …",
  "matchflow.accept.loadError": "Einladung ungültig oder abgelaufen",
  "matchflow.accept.submitError": "Bestätigung fehlgeschlagen",
  "matchflow.accept.successTitle": "Danke — Vertrag bestätigt",
  "matchflow.accept.successBody":
    "Die Bestätigung ist bei MatchFlow hinterlegt. Du kannst dieses Fenster schließen.",
  "matchflow.agreements.title": "Trainingsvereinbarung anlegen",
  "matchflow.agreements.lead":
    "Preis-, Raten- und Ausfallregeln versioniert speichern. Verknüpfungen (Serie/Personen) sind optional.",
  "matchflow.agreements.listTitle": "Vereinbarungen des Kunden",
  "matchflow.agreements.empty": "Keine Vereinbarungen für diesen Kunden.",
  "matchflow.agreements.loadError":
    "Vereinbarungen konnten nicht geladen werden.",
  "matchflow.agreements.saveError": "Speichern fehlgeschlagen.",
  "matchflow.agreements.saved": "Vereinbarung gespeichert.",
  "matchflow.agreements.save": "Version speichern",
  "matchflow.agreements.field.tenant": "Kunde",
  "matchflow.agreements.field.tenantPlaceholder": "Verein wählen…",
  "matchflow.agreements.noClients":
    "Noch keine Kundenvereine zugewiesen — deshalb ist die Auswahl leer.",
  "matchflow.agreements.field.seriesId": "Serien-ID (optional)",
  "matchflow.agreements.field.seriesIdHint":
    "Optional: ID einer Trainings-Serie, falls die Vereinbarung an eine Serie gebunden werden soll.",
  "matchflow.agreements.field.partner": "Vertragspartner-Person-ID (optional)",
  "matchflow.agreements.field.beneficiary":
    "Leistungsempfänger-Person-ID (optional)",
  "matchflow.agreements.field.idsHint":
    "Die Personen-/Serien-Felder kannst du leer lassen. Später kommen Auswahl-Picker; vorerst nur technische IDs.",
  "matchflow.agreements.field.pricingKind": "Preisart",
  "matchflow.agreements.pricing.per_session": "Pro Termin",
  "matchflow.agreements.pricing.season_flat": "Saison-Pauschale",
  "matchflow.agreements.pricing.hourly_split": "Stunden-Anteil",
  "matchflow.agreements.field.priceEur": "Preis EUR",
  "matchflow.agreements.field.sessionCount": "Termine",
  "matchflow.agreements.field.installments": "Raten",
  "matchflow.agreements.field.cancellation": "Ausfallregel",
  "matchflow.agreements.col.status": "Status",
  "matchflow.agreements.col.series": "Serie",
  "matchflow.agreements.col.version": "Version",
  "matchflow.agreements.col.price": "Preis",
};
